import request from "../request";

export const getApiServices = () =>
  request.get("setting/api-and-services").then((res) => res);

export const createApiServices = (data) =>
  request.post("setting/api-and-services", data).then((res) => res);

export const deleteApiServices = (id) =>
  request.delete(`setting/api-and-services/${id}`).then((res) => res);
